import { render, staticRenderFns } from "./AnswerAcceptPopup.vue?vue&type=template&id=59cf6ba6&scoped=true"
import script from "./AnswerAcceptPopup.vue?vue&type=script&lang=js"
export * from "./AnswerAcceptPopup.vue?vue&type=script&lang=js"
import style0 from "./AnswerAcceptPopup.vue?vue&type=style&index=0&id=59cf6ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cf6ba6",
  null
  
)

export default component.exports